export const isIos =
  typeof navigator !== 'undefined' &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent || '') ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

export const isAndroid =
  typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('android') > -1;

export const isMac = typeof navigator !== 'undefined' && /Mac/.test(navigator.userAgent || '');
